<div class="w-full mx-auto p-5 space-y-5">

  <!-- ============================================================ -->
  <!-- Header                                                       -->
  <!-- ============================================================ -->
  <div class="flex flex-wrap justify-between items-end gap-4">
    <div>
      <div class="flex items-center gap-2 text-xs font-medium text-slate-500 uppercase tracking-wider">
        <span>Tesorería</span>
        <span class="text-slate-300">/</span>
        <span class="text-slate-700">Conciliaciones bancarias</span>
      </div>
      <h1 class="text-2xl font-semibold text-slate-900 mt-1">Conciliaciones Bancarias</h1>
      <p class="text-sm text-slate-500 mt-1">Gestión y seguimiento de conciliaciones bancarias</p>
    </div>
    <div class="flex flex-wrap gap-2">
      <button (click)="openClosingModal()" class="btn btn-secondary">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
        Cerrar Período
      </button>
      <button (click)="createNewReconciliation()" class="btn btn-primary">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
        </svg>
        Nueva Conciliación
      </button>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Toolbar de filtros                                           -->
  <!-- ============================================================ -->
  <div class="filters-toolbar">

    <div class="flex items-center justify-between mb-3">
      <h3 class="text-xs font-semibold text-slate-600 uppercase tracking-wider flex items-center gap-2">
        <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z" />
        </svg>
        Filtros y búsqueda
      </h3>
      <button (click)="toggleFilters()" class="text-xs text-blue-600 hover:text-blue-800 font-medium flex items-center gap-1">
        <span>{{ showFilters ? 'Ocultar' : 'Mostrar' }}</span>
        <svg class="w-3 h-3 transition-transform" [ngClass]="{'rotate-180': showFilters}" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
    </div>

    <div *ngIf="showFilters" class="grid grid-cols-12 gap-3">
      <div class="col-span-12 md:col-span-4">
        <p-dropdown [(ngModel)]="filters.bankId" [options]="banks" placeholder="Banco" optionLabel="label"
          optionValue="value" [showClear]="true" [filter]="true" filterBy="label" (onChange)="onFilterChange()"
          appendTo="body" panelStyleClass="filter-dropdown-panel" styleClass="w-full" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <div class="col-span-12 md:col-span-3">
        <p-dropdown [(ngModel)]="filters.status" [options]="statusOptions" placeholder="Estado" optionLabel="label"
          optionValue="value" (onChange)="onFilterChange()" appendTo="body" panelStyleClass="filter-dropdown-panel"
          styleClass="w-full" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <div class="col-span-12 md:col-span-3">
        <div class="relative">
          <svg class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input type="text" [(ngModel)]="filters.searchTerm" placeholder="Buscar por notas..."
            class="w-full pl-9 pr-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400">
        </div>
      </div>

      <div class="col-span-12 md:col-span-2 flex justify-end">
        <button (click)="clearFilters()" class="btn btn-ghost btn-sm">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Limpiar
        </button>
      </div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Loading                                                      -->
  <!-- ============================================================ -->
  <div *ngIf="loading" class="bg-white border border-slate-200 rounded-xl p-10 text-center">
    <svg class="animate-spin h-6 w-6 mx-auto mb-2 text-slate-400" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
    </svg>
    <p class="text-sm text-slate-500">Cargando conciliaciones…</p>
  </div>

  <!-- ============================================================ -->
  <!-- Tabla                                                        -->
  <!-- ============================================================ -->
  <div *ngIf="!loading" class="rounded-xl border border-slate-200 bg-white overflow-hidden">

    <!-- Header de tabla -->
    <div class="px-4 py-3 border-b border-slate-100 flex items-center justify-between bg-white">
      <h2 class="text-sm font-semibold text-slate-700">Lista de conciliaciones</h2>
      <span class="text-xs text-slate-500 tabular-nums">{{ getPaginationInfo() }}</span>
    </div>

    <div class="overflow-x-auto">
      <table class="enrollment-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Banco</th>
            <th>Tipo</th>
            <th>Período</th>
            <th>Estado</th>
            <th class="text-right">Monto banco</th>
            <th class="text-right">Progreso</th>
            <th>Auditoría</th>
            <th class="text-right">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let reconciliation of reconciliations">

            <td class="font-medium text-slate-700 tabular-nums">#{{ reconciliation.id }}</td>

            <td>
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H9m0 0H7m2 0v-5a2 2 0 012-2h2a2 2 0 012 2v5m-6 0V9a2 2 0 012-2h2a2 2 0 012 2v8" />
                </svg>
                <span class="font-semibold text-slate-800">{{ getBankName(reconciliation) }}</span>
              </div>
            </td>

            <td>
              <span class="pill" [ngClass]="{
                'pill-emerald': reconciliation.reconciliationType === 'INCOME',
                'pill-rose':    reconciliation.reconciliationType === 'EXPENSE',
                'pill-violet':  reconciliation.reconciliationType === 'BOTH'
              }">
                {{ getReconciliationTypeDisplayName(reconciliation.reconciliationType) }}
              </span>
            </td>

            <td>
              <div class="data-cell">
                <span class="data-value tabular-nums">{{ formatDate(reconciliation.periodFrom) }}</span>
                <span class="data-sub tabular-nums">→ {{ formatDate(reconciliation.periodTo) }}</span>
              </div>
            </td>

            <td>
              <span class="pill" [ngClass]="getStatusBadgeClass(reconciliation.status)">
                {{ getStatusDisplayName(reconciliation.status) }}
              </span>
            </td>

            <td class="text-right">
              <div class="data-cell" style="align-items: flex-end;">
                <span class="data-value tabular-nums">{{ formatCurrency(reconciliation.amounts?.bankAmount || 0) }}</span>
                <span class="data-sub tabular-nums">Conc.: {{ formatCurrency(reconciliation.amounts?.reconciledAmount || 0) }}</span>
              </div>
            </td>

            <td class="text-right">
              <div class="flex items-center justify-end gap-2">
                <div class="progress-bar">
                  <div class="progress-fill" [style.width.%]="getProgressPercentage(reconciliation)"></div>
                </div>
                <span class="text-xs font-semibold text-slate-700 tabular-nums w-8">{{ getProgressPercentage(reconciliation).toFixed(0) }}%</span>
              </div>
              <div class="text-[11px] text-slate-400 text-right mt-1 tabular-nums">
                {{ reconciliation.counters?.reconciledCount || 0 }}/{{ reconciliation.counters?.totalReceipts || 0 }} comp.
              </div>
            </td>

            <td>
              <app-audit-info [auditData]="{
                  createdBy: reconciliation.createdBy,
                  createdAt: reconciliation.createdAt,
                  updatedBy: reconciliation.updatedBy,
                  updatedAt: reconciliation.updatedAt,
                  deletedBy: reconciliation.deletedBy,
                  deletedAt: reconciliation.deletedAt,
                  isDeleted: reconciliation.isDeleted
                }" layout="compact" size="sm">
              </app-audit-info>
            </td>

            <td class="text-right">
              <div class="inline-flex items-center gap-1">
                <button (click)="viewReconciliation(reconciliation)" class="row-action row-action--primary" title="Ver detalles">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  <span>Ver</span>
                </button>
                <button (click)="downloadReconciliationReport(reconciliation)"
                  [disabled]="!canDownloadReport(reconciliation)" class="row-action row-action--success"
                  title="Descargar reporte Excel">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                  </svg>
                  <span>Excel</span>
                </button>
                <button (click)="cancelReconciliation(reconciliation)"
                  [disabled]="!canCancelReconciliation(reconciliation)" class="row-action row-action--danger"
                  title="Cancelar conciliación">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </td>
          </tr>

          <!-- Empty state -->
          <tr *ngIf="reconciliations.length === 0">
            <td colspan="9" class="text-center py-10">
              <div class="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3">
                <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <p class="text-sm font-medium text-slate-700">No hay conciliaciones registradas</p>
              <p class="text-xs text-slate-500 mt-1 mb-3">Comenzá creando tu primera conciliación bancaria.</p>
              <button (click)="createNewReconciliation()" class="btn btn-secondary btn-sm inline-flex">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                </svg>
                Crear primera conciliación
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div *ngIf="totalPages > 1" class="border-t border-slate-100 px-4 py-3 flex items-center justify-between text-sm">
      <span class="text-xs text-slate-500 tabular-nums">{{ getPaginationInfo() }}</span>
      <div class="flex items-center gap-1">
        <button (click)="previousPage()" [disabled]="currentPage === 1" class="btn btn-ghost btn-sm">
          <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        </button>
        <button *ngFor="let page of getVisiblePages()" (click)="goToPage(page)"
          class="btn btn-sm" [ngClass]="page === currentPage ? 'btn-primary' : 'btn-ghost'"
          style="min-width: 36px; padding: 0;">
          <span class="tabular-nums">{{ page }}</span>
        </button>
        <button (click)="nextPage()" [disabled]="currentPage === totalPages" class="btn btn-ghost btn-sm">
          <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Modal Cierre de Período (wizard 3 pasos)                     -->
  <!-- ============================================================ -->
  <p-dialog [(visible)]="showClosingModal" [modal]="true" [style]="{width: '1100px', maxWidth: '95vw'}"
    [draggable]="false" [resizable]="false" header="Cerrar Período Bancario">

    <!-- Wizard steps -->
    <div class="wizard-steps mb-6">
      <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
        <div class="step-circle" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">1</div>
        <span class="step-label">Selección</span>
      </div>
      <div class="step-line" [class.completed]="currentStep > 1"></div>
      <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
        <div class="step-circle" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">2</div>
        <span class="step-label">Revisión</span>
      </div>
      <div class="step-line" [class.completed]="currentStep > 2"></div>
      <div class="step" [class.active]="currentStep === 3">
        <div class="step-circle" [class.active]="currentStep === 3">3</div>
        <span class="step-label">Confirmación</span>
      </div>
    </div>

    <div class="p-2">
      <!-- STEP 1: SELECCIÓN -->
      <div *ngIf="currentStep === 1" class="space-y-4">
        <div>
          <label for="bank" class="block text-xs font-semibold text-slate-600 uppercase tracking-wider mb-2">Banco</label>
          <p-dropdown id="bank" [options]="banks" [(ngModel)]="closingData.bankId" optionLabel="label"
            optionValue="value" placeholder="Seleccione un banco" appendTo="body" styleClass="w-full"
            [style]="{'width':'100%'}">
          </p-dropdown>
        </div>

        <div>
          <label class="block text-xs font-semibold text-slate-600 uppercase tracking-wider mb-2">Período</label>
          <div class="grid grid-cols-2 gap-3">
            <p-dropdown [options]="months" [(ngModel)]="closingData.month" optionLabel="label" optionValue="value"
              placeholder="Mes" appendTo="body" styleClass="w-full" [style]="{'width':'100%'}">
            </p-dropdown>
            <input type="number" [(ngModel)]="closingData.year"
              class="w-full h-[38px] px-3 border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent tabular-nums"
              placeholder="Año">
          </div>
        </div>
      </div>

      <!-- STEP 2: REVISIÓN -->
      <div *ngIf="currentStep === 2">
        <h6 class="text-sm font-semibold text-slate-700 mb-3">Comprobantes del período</h6>

        <div *ngIf="loadingVouchers" class="text-center py-8">
          <svg class="animate-spin h-6 w-6 mx-auto mb-2 text-slate-400" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
          <p class="text-sm text-slate-500">Cargando comprobantes…</p>
        </div>

        <div *ngIf="!loadingVouchers && periodDetails">
          <div class="grid grid-cols-3 gap-3 mb-4">
            <div class="kpi-card kpi-sky">
              <div class="kpi-label">Total comprobantes</div>
              <div class="kpi-value">{{ periodDetails.totalVouchers }}</div>
            </div>
            <div class="kpi-card kpi-emerald">
              <div class="kpi-label">Conciliados</div>
              <div class="kpi-value">{{ periodDetails.reconciledCount }}</div>
            </div>
            <div class="kpi-card kpi-amber">
              <div class="kpi-label">Sin conciliar</div>
              <div class="kpi-value">{{ periodDetails.unreconciledCount }}</div>
            </div>
          </div>

          <p-table [value]="periodDetails.vouchers" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20,50]"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first}–{last} de {totalRecords}">
            <ng-template pTemplate="header">
              <tr>
                <th>ID</th>
                <th>Tipo</th>
                <th>Documento</th>
                <th>Creación</th>
                <th>Pago</th>
                <th class="text-right">Monto</th>
                <th>Conciliado</th>
                <th>Tipo conc.</th>
                <th>Comprobante</th>
                <th>Conciliación</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-voucher>
              <tr>
                <td class="tabular-nums">{{ voucher.voucherId }}</td>
                <td>
                  <span class="pill" [ngClass]="voucher.voucherType === 'INCOME' ? 'pill-emerald' : 'pill-rose'">
                    {{ voucher.voucherType === 'INCOME' ? 'Ingreso' : 'Egreso' }}
                  </span>
                </td>
                <td>{{ voucher.documentNumber }}</td>
                <td class="tabular-nums">{{ voucher.createdAt | date:'dd/MM/yy' }}</td>
                <td class="tabular-nums">{{ voucher.paymentDate | date:'dd/MM/yy' }}</td>
                <td class="text-right tabular-nums">{{ voucher.amount | currency }}</td>
                <td>
                  <span class="pill" [ngClass]="voucher.isReconciled ? 'pill-emerald' : 'pill-amber'">
                    {{ voucher.isReconciled ? 'Sí' : 'No' }}
                  </span>
                </td>
                <td class="text-xs text-slate-500">{{ voucher.reconciliationType || '—' }}</td>
                <td>
                  <button (click)="openVoucher(voucher.voucherType, voucher.voucherId)"
                    class="text-blue-600 hover:text-blue-800 inline-flex items-center gap-1 text-xs">
                    Ver <i class="pi pi-external-link text-[10px]"></i>
                  </button>
                </td>
                <td>
                  <button *ngIf="voucher.bankReconciliationId" (click)="openReconciliation(voucher.bankReconciliationId)"
                    class="text-blue-600 hover:text-blue-800 inline-flex items-center gap-1 text-xs">
                    Ver <i class="pi pi-external-link text-[10px]"></i>
                  </button>
                  <span *ngIf="!voucher.bankReconciliationId" class="text-slate-400 text-xs">—</span>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr><td colspan="10" class="text-center text-slate-500 py-4 text-sm">No se encontraron comprobantes para este período</td></tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      <!-- STEP 3: CONFIRMACIÓN -->
      <div *ngIf="currentStep === 3">
        <div *ngIf="loadingSummary" class="text-center py-8">
          <svg class="animate-spin h-6 w-6 mx-auto mb-2 text-slate-400" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
          <p class="text-sm text-slate-500">Cargando resumen…</p>
        </div>

        <div *ngIf="preClosingSummary && !loadingSummary" class="space-y-4">
          <h6 class="text-sm font-semibold text-slate-700 flex items-center gap-2">
            <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            Resumen del período
          </h6>

          <div class="grid grid-cols-2 gap-3">
            <div class="kpi-card kpi-emerald">
              <div class="kpi-label">Total créditos</div>
              <div class="kpi-value">{{ preClosingSummary.totalCredits | currency }}</div>
            </div>
            <div class="kpi-card kpi-rose">
              <div class="kpi-label">Total débitos</div>
              <div class="kpi-value">{{ preClosingSummary.totalDebits | currency }}</div>
            </div>
            <div class="kpi-card kpi-slate">
              <div class="kpi-label">Saldo inicial</div>
              <div class="kpi-value">{{ preClosingSummary.projectedStarBalance | currency }}</div>
            </div>
            <div class="kpi-card kpi-sky">
              <div class="kpi-label">Saldo final proyectado</div>
              <div class="kpi-value">{{ preClosingSummary.projectedEndBalance | currency }}</div>
            </div>
          </div>

          <div class="bg-white border border-slate-200 rounded-xl p-4 flex items-center justify-between gap-4">
            <div>
              <span class="text-xs font-semibold text-slate-500 uppercase tracking-wider block mb-1">Comprobantes sin conciliar</span>
              <div class="text-sm">
                <span class="font-semibold text-amber-700">Ingresos: <span class="tabular-nums">{{ preClosingSummary.unreconciledIncomeCount }}</span></span>
                <span class="text-slate-300 mx-2">·</span>
                <span class="font-semibold text-amber-700">Egresos: <span class="tabular-nums">{{ preClosingSummary.unreconciledExpenseCount }}</span></span>
              </div>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold text-slate-500 uppercase tracking-wider block mb-1">Conciliaciones pendientes</span>
              <span class="text-lg font-bold tabular-nums"
                [class.text-amber-700]="preClosingSummary.pendingReconciliationsCount > 0"
                [class.text-emerald-700]="preClosingSummary.pendingReconciliationsCount === 0">
                {{ preClosingSummary.pendingReconciliationsCount }}
              </span>
            </div>
          </div>

          <div *ngIf="preClosingSummary.warningMessage" class="alert-banner alert-amber">
            <i class="fas fa-exclamation-triangle alert-icon"></i>
            <div class="alert-body">
              <p class="alert-text">{{ preClosingSummary.warningMessage }}</p>
            </div>
          </div>

          <div class="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3">
            <input type="checkbox" id="confirmClosing" [(ngModel)]="confirmationCheck" class="h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500">
            <label for="confirmClosing" class="text-sm font-medium text-slate-700 cursor-pointer">
              Confirmo que revisé todos los comprobantes y deseo cerrar este período
            </label>
          </div>
        </div>

        <div *ngIf="errorMessage && !loadingSummary" class="alert-banner alert-rose mt-4">
          <i class="fas fa-times-circle alert-icon"></i>
          <div class="alert-body">
            <p class="alert-text">{{ errorMessage }}</p>
          </div>
        </div>
      </div>

      <!-- Error message (steps 1 & 2) -->
      <div *ngIf="errorMessage && currentStep !== 3" class="alert-banner alert-rose mt-4">
        <i class="fas fa-times-circle alert-icon"></i>
        <div class="alert-body">
          <p class="alert-text">{{ errorMessage }}</p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <ng-template pTemplate="footer">
      <div class="flex justify-between gap-2">
        <button *ngIf="currentStep > 1" (click)="previousStep()" type="button" class="btn btn-secondary">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          Atrás
        </button>
        <div class="flex-1"></div>
        <button (click)="closeClosingModal()" type="button" class="btn btn-ghost">Cancelar</button>
        <button *ngIf="currentStep < 3" (click)="nextStep()" [disabled]="!canProceedToNextStep()" type="button" class="btn btn-primary">
          Siguiente
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </button>
        <button *ngIf="currentStep === 3" (click)="submitClosing()"
          [disabled]="!confirmationCheck || !preClosingSummary?.canClose" type="button" class="btn btn-rose">
          <i class="fas fa-lock"></i> Cerrar período
        </button>
      </div>
    </ng-template>
  </p-dialog>
</div>
